import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {CustomAttributeModel} from '../../../models/api/customFieldModel';
import {AppState} from '../../../store/appState';
import {makeGetCardCrmSyncEditLinkForField} from '../../../store/data/crmSync/crmSyncsSelectors';
import {CustomAttribute} from './customAttribute';

/*
 * Props.
 */

interface CustomAttributeContainerProps {
  card?: CardModel;
  customAttribute: CustomAttributeModel;
}

/*
 * Selectors.
 */

function getCard(_state: AppState, props: CustomAttributeContainerProps) {
  return props.card;
}

function getFieldId(_state: AppState, props: CustomAttributeContainerProps) {
  return props.customAttribute.customField.id;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CustomAttributeContainerProps>()(() => ({
  crmSyncEditLink: makeGetCardCrmSyncEditLinkForField(getFieldId, getCard),
}));

export const CustomAttributeContainer = connect(mapStateToProps)(CustomAttribute);
